import { render, staticRenderFns } from "./law-settle.vue?vue&type=template&id=9e148c90&scoped=true"
import script from "./law-settle.vue?vue&type=script&lang=js"
export * from "./law-settle.vue?vue&type=script&lang=js"
import style0 from "./law-settle.vue?vue&type=style&index=0&id=9e148c90&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e148c90",
  null
  
)

export default component.exports